export default "__VITE_ASSET__BcIuab0J__"